import {Injectable} from "@angular/core";

@Injectable({
  providedIn:'root'
})
export class DeviceDetectorService {

  private mobileDevices = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i
  ];

  isMobileDevice() {
    return this.mobileDevices.some((item) => {
      return navigator.userAgent.match(item);
    });
  }

}
